import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { PriceModel } from './Price.model';
import { AdditionalFeeSource as ServerAdditionalFeeSource } from '@wix/auto_sdk_ecom_checkout';
export let AdditionalFeeSource = /*#__PURE__*/function (AdditionalFeeSource) {
  AdditionalFeeSource["UNKNOWN_ADDITIONAL_FEE_SOURCE"] = "UNKNOWN_ADDITIONAL_FEE_SOURCE";
  AdditionalFeeSource["SERVICE_PLUGIN"] = "SERVICE_PLUGIN";
  AdditionalFeeSource["ITEM"] = "ITEM";
  AdditionalFeeSource["MANUAL"] = "MANUAL";
  AdditionalFeeSource["SHIPPING"] = "SHIPPING";
  return AdditionalFeeSource;
}({});
const additionalFeeSourceMap = {
  [ServerAdditionalFeeSource.UNKNOWN_ADDITIONAL_FEE_SOURCE]: AdditionalFeeSource.UNKNOWN_ADDITIONAL_FEE_SOURCE,
  [ServerAdditionalFeeSource.SERVICE_PLUGIN]: AdditionalFeeSource.SERVICE_PLUGIN,
  [ServerAdditionalFeeSource.ITEM]: AdditionalFeeSource.ITEM,
  [ServerAdditionalFeeSource.MANUAL]: AdditionalFeeSource.MANUAL,
  [ServerAdditionalFeeSource.SHIPPING]: AdditionalFeeSource.SHIPPING
};
export class AdditionalFeeModel {
  constructor(additionalFeeModel) {
    _defineProperty(this, "price", void 0);
    _defineProperty(this, "code", void 0);
    _defineProperty(this, "name", void 0);
    _defineProperty(this, "source", void 0);
    this.price = additionalFeeModel.price;
    this.code = additionalFeeModel.code;
    this.name = additionalFeeModel.name;
    this.source = additionalFeeModel.source;
  }
  static fromV1(additionalFee, modelContext) {
    return new AdditionalFeeModel({
      price: PriceModel.fromV1(additionalFee.price, modelContext),
      code: additionalFee.code,
      name: additionalFee.translatedName ?? additionalFee.name,
      source: additionalFee.source ? additionalFeeSourceMap[additionalFee.source] : AdditionalFeeSource.UNKNOWN_ADDITIONAL_FEE_SOURCE
    });
  }
}
//# sourceMappingURL=AdditionalFee.model.js.map